import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { AuthService } from '../../../services';
import { PublishedMatch } from '../../../models';

@Component({
  selector: 'favorite-match-button',
  templateUrl: './favorite-match-button.component.html'
})
export class FavoriteMatchButtonComponent implements OnInit {
  
  @Input() mode: string = '';
  @Input() match: PublishedMatch;
  @Output() readonly addFavorite = new EventEmitter<PublishedMatch>();
  @Output() readonly removeFavorite = new EventEmitter<PublishedMatch>();

  isAdd = true;
  icon_name = 'favorite_border';
  tooltipText = 'Add to Favorites';

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    if(this.mode && this.mode.toLowerCase() === 'remove') {
      this.isAdd = false;
      this.icon_name = 'favorite'
      this.tooltipText = 'Remove from Favorites'
    }
  }

  onFavorite(match: PublishedMatch) {
    if(this.isAdd) {
      this.addFavorite.emit(match);
    }else{
      this.removeFavorite.emit(match);
    }

  }
}
